// Firebase authentication disabled - using real backend

// Dummy implementations to avoid breaking imports
class FirebaseAuthBackend {
  constructor(firebaseConfig: any) {}
  registerUser = (email: any, password: any) => Promise.resolve(null);
  loginUser = (email: any, password: any) => Promise.resolve(null);
  forgetPassword = (email: any) => Promise.resolve(null);
  logout = () => Promise.resolve();
  addNewUserToFirestore = (user: any) => Promise.resolve();
  setLoggeedInUser = (user: any) => {};
  socialLoginUser = (type: any) => Promise.resolve(null);
}

let _fireBackend: FirebaseAuthBackend | null = null;

const initFirebaseBackend = (config: any) => {
  if (!_fireBackend) {
    _fireBackend = new FirebaseAuthBackend(config);
  }
  return _fireBackend;
};

const getFirebaseBackend = () => {
  return _fireBackend;
};

export { initFirebaseBackend, getFirebaseBackend };
